import { Input as BaseInput } from '@base-ui/react/input';
import type { ComponentProps } from 'react';
import { cva, cx, type VariantProps } from '@/cva.config';

export const inputVariants = cva({
  base: [
    'w-full rounded-md border border-border text-foreground transition-colors outline-none placeholder:text-foreground-muted/40',
  ],
  defaultVariants: {
    font: 'sans',
    size: 'md',
    variant: 'default',
  },
  variants: {
    font: {
      mono: 'font-mono',
      sans: '',
    },
    size: {
      md: 'bg-surface/60 px-3 py-2 text-sm lg:text-base focus:border-accent/40 focus:ring-2 focus:ring-accent/20',
      sm: 'h-8 bg-surface px-2.5 text-sm lg:text-base placeholder:text-subtle/70 focus:border-accent',
    },
    variant: {
      accent:
        'bg-accent/10 text-accent hover:bg-accent/15 focus:border-accent/40',
      default: '',
    },
  },
});

export interface InputProps
  extends Omit<ComponentProps<typeof BaseInput>, 'size'>,
    VariantProps<typeof inputVariants> {}

export const Input = ({
  className,
  font,
  size,
  variant,
  ...props
}: InputProps) => (
  <BaseInput
    className={cx(inputVariants({ font, size, variant }), className)}
    {...props}
  />
);
